export const TRANSLATION_GROUP_MIRRORS_CREATE = Symbol('admin.mirrors-list.create');

export const MIRRORS_LIST_CREATE_JS_ROUTE_NAME = Symbol('admin.mirrors-list.create-js');
export const MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME = Symbol('admin.mirrors-list.create-no-js');
